import { Activity } from 'react';
import Button from '@ui/buttons/button/button';
import Container from '@ui/container/container';
import Text from '@ui/text/text/text';
import Icon from '@ui/icons/icon';
import { ICONS } from '@ui/icons/types';
import { EColorVariablesV2 } from '@/types/theme-packs.types';
import getThemeColorContrastCSSVariable from '@/utils/colors/get-theme-color-contrast-css-variable';
import getThemeColorsCssMixVariable from '@/utils/colors/get-theme-color-css-mix-variable';
import getThemeColorCSSVariable from '@/utils/colors/get-theme-color-css-variable';

interface AllProfilesBulkActionsProps {
  selectedCount: number;
  onClearSelection: () => void;
  onAddToList: () => void;
}

const AllProfilesBulkActions = ({ selectedCount, onClearSelection, onAddToList }: AllProfilesBulkActionsProps) => {
  return (
    <Activity mode={selectedCount > 0 ? 'visible' : 'hidden'}>
      <Container
        className="flex flex-row padding-v-10 padding-h-24 radius-8 jc-space-between"
        background="var(--global-opacity-white-5)"
        height="60px"
      >
        <Container className="S1 flex ai-center">
          {selectedCount > 0 ? `${selectedCount} profile${selectedCount === 1 ? '' : 's'} selected` : null}
        </Container>
        <Container className="flex fa-row gap-8 no-style">
          <Button onClick={onClearSelection}>
            <Text className="L2 flex ai-center gap-6">
              <Icon name={ICONS.CLOSE} height={11} width={11} />
              <span>Clear selection</span>
            </Text>
          </Button>
          <Button
            minWidth="max-content"
            className="padding-8 flex ai-center jc-center gap-6"
            borderRadius="100px"
            onClick={onAddToList}
            backgroundColor={getThemeColorCSSVariable()}
            hoverBackgroundColor={getThemeColorsCssMixVariable()}
            designSize="small"
            disabled={selectedCount === 0}
          >
            <Icon
              color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}
              name={ICONS.ADD}
              size={12}
            />
            <Text color={getThemeColorContrastCSSVariable(EColorVariablesV2.buttonText, EColorVariablesV2.primary)}>
              Add to list
            </Text>
          </Button>
        </Container>
      </Container>
    </Activity>
  );
};

export default AllProfilesBulkActions;
